var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "insta",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.489,
    height: 22.484,
    viewBox: "0 0 22.489 22.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.018,
    cy: 0.908,
    r: 1.446,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fed576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#f47133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#bc3081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c63d2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.018,
    cy: 0.908,
    r: 1.446,
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6690",
    "data-name": "Group 6690"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14983",
    "data-name": "Path 14983",
    d: "M15.081,10.89a5.767,5.767,0,0,0-3.291,3.286,8.222,8.222,0,0,0-.521,2.729c-.055,1.2-.069,1.582-.069,4.635s.014,3.437.069,4.635A8.34,8.34,0,0,0,11.79,28.9a5.757,5.757,0,0,0,3.291,3.291,8.222,8.222,0,0,0,2.729.521c1.2.055,1.582.069,4.635.069s3.437-.014,4.635-.069a8.34,8.34,0,0,0,2.729-.521A5.757,5.757,0,0,0,33.1,28.9a8.222,8.222,0,0,0,.521-2.729c.055-1.2.069-1.582.069-4.635S33.675,18.1,33.62,16.9a8.34,8.34,0,0,0-.521-2.729,5.742,5.742,0,0,0-3.286-3.286,8.222,8.222,0,0,0-2.729-.521c-1.2-.055-1.582-.069-4.635-.069s-3.437.014-4.635.069A8.113,8.113,0,0,0,15.081,10.89Zm11.907,1.5a6.194,6.194,0,0,1,2.089.389,3.72,3.72,0,0,1,2.135,2.135A6.194,6.194,0,0,1,31.6,17c.055,1.184.064,1.54.064,4.543s-.014,3.36-.064,4.543a6.194,6.194,0,0,1-.389,2.089,3.72,3.72,0,0,1-2.135,2.135,6.194,6.194,0,0,1-2.089.389c-1.184.055-1.54.064-4.543.064s-3.36-.014-4.543-.064a6.194,6.194,0,0,1-2.089-.389,3.72,3.72,0,0,1-2.135-2.135,6.194,6.194,0,0,1-.389-2.089c-.055-1.184-.064-1.54-.064-4.543s.014-3.36.064-4.543a6.194,6.194,0,0,1,.389-2.089,3.72,3.72,0,0,1,2.135-2.135,6.194,6.194,0,0,1,2.089-.389c1.184-.055,1.54-.064,4.543-.064S25.8,12.334,26.988,12.389Z",
    transform: "translate(-11.2 -10.3)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14984",
    "data-name": "Path 14984",
    d: "M130.9,135.161A5.161,5.161,0,1,0,136.061,130,5.161,5.161,0,0,0,130.9,135.161Zm8.511,0a3.351,3.351,0,1,1-3.351-3.351A3.35,3.35,0,0,1,139.411,135.161Z",
    transform: "translate(-124.817 -123.917)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3329",
    "data-name": "Ellipse 3329",
    cx: 1.499,
    cy: 1.499,
    r: 1.499,
    transform: "translate(15.66 3.835)",
    fill: "#654c9f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.c252e6f810e115fbc73a06dfa14af613.svg";
export { ForwardRef as ReactComponent };